import { createTheme } from '@mui/material/styles';
import type { PaletteOptions } from '@mui/material/styles';

import { dndPalette } from './themes/dndTheme';
import { fbPalette } from './themes/fbTheme';
import { fhbfPalette } from './themes/fhbfTheme';
import { fhfPalette } from './themes/fhfTheme';

const reactAppVersion = process.env.REACT_APP_VERSION;

const loadTheme = (location: string): PaletteOptions | undefined => {
  if (reactAppVersion === 'dnd') {
    return dndPalette;
  }
  if (reactAppVersion === 'fb') {
    return fbPalette;
  }
  if (reactAppVersion === 'fhbf') {
    return fhbfPalette(location);
  }
  if (reactAppVersion === 'fhf') {
    return fhfPalette();
  }
  return undefined;
};

const theme = (location: string) =>
  createTheme({
    palette: loadTheme(location),
  });

export default theme;
